import { useEffect } from 'react';

export const usePopstate = (listener) => {
  useEffect(() => {
    window.addEventListener('popstate', listener);

    return () => {
      window.removeEventListener('popstate', listener);
    };
  }, [listener]);
};
